import Twitter from '@assets/icons/twitter.svg'
import { Icon } from './Icon'

export const TwitterIcon = Icon(Twitter)
